import React from 'react'
import Edit from '../crud/edit'
import menuItems from './menuItems'

const fields = [
  {
    name: 'Session Sale Default Plan Code',
    prop: 'value',
    type: 'autocomplete',
    references: 'admin/membership_plans',
    referenceProp: 'code',
    referenceValue: 'code'
  }
]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Session Sale Default Plan Code'
      fields={fields}
      apiPath='admin/settings/session_sale_default_plan_code'
      successRedirectPath='/settings'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
